module.exports = __webpack_public_path__ + "img/thunderstorm.e62d192e.svg";